import { Component, Input } from '@angular/core';
import { OnDynamicData, OnDynamicMount } from 'ngx-dynamic-hooks';

import { parseFrameString } from '../../../../utils/utils';

@Component({
  selector: 'kh-pane',
  templateUrl: 'kh-manip-pane.component.html',
  styleUrls: ['kh-manip-pane.component.less'],
  standalone: false
})
export class KhManipulativePaneComponent implements OnDynamicMount {
  @Input() public key = '';
  @Input() public value = '';
  @Input() public image = '';
  @Input() public frame = '0 0 100 100';
  
  private _order!: number;

  @Input() 
  public set order(value: string | number) {
    this._order = typeof value === 'string' ? parseInt(value, 10) : value;
  }
  
  public get order(): number {
    return this._order;
  }
  
  @Input() public visibility = 'hidden';
  @Input('ignore-in-score') public ignoreInScore = false;

  public box = { left: 0, top: 0, width: 0, height: 0 };

  public onDynamicMount(data: OnDynamicData): void {
    const frame = parseFrameString(this.frame);
    this.box = { left: frame.x, top: frame.y, width: frame.width, height: frame.height };
  }
}
